const navLinksArr = [
  { name: "Music", route: "/music" },
  { name: "Playlists", route: "/playlists" },
  { name: "About", route: "/about" },
  { name: "Contact", route: "/contact" },
]

export default navLinksArr
